import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva('inline-flex items-center justify-center gap-2 rounded-md border text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50', {
  variants: {
    variant: { default: 'border-primary bg-primary text-primary-foreground hover:bg-primary/90', outline: 'border-border bg-transparent hover:bg-muted', ghost: 'border-transparent hover:bg-muted', danger: 'border-danger/40 bg-danger/10 text-danger hover:bg-danger/20' },
    size: { default: 'h-9 min-h-11 px-3 md:min-h-0', sm: 'h-8 min-h-11 px-2.5 text-xs md:min-h-0', lg: 'h-10 min-h-12 px-5 md:min-h-0' },
  }, defaultVariants: { variant: 'default', size: 'default' },
})

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, ...props }, ref) => <button ref={ref} className={cn(buttonVariants({ variant, size, className }))} {...props} />)
Button.displayName = 'Button'
